<template>
  <div class="col px-0 contact d-flex flex-column">
    <div class="content-title">
      <div class="media">
        <div class="media-body">
          <h1>
            {{ $t(`feature.staff.title`) }}
          </h1>
          <breadcrumbs :labels="breadcrumbsLabels"></breadcrumbs>
        </div>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import Breadcrumbs from "./Breadcrumbs";

export default {
  components: {
    Breadcrumbs
  },
  data() {
    return {
      breadcrumbsLabels: null
    };
  },
  watch: {
    $route() {
      this.setBreadcrumbs();
    }
  },
  created() {
    this.setBreadcrumbs();

    this.$on("change:staff", value => {
      this.setBreadcrumbs(value);
    });
  },
  methods: {
    setBreadcrumbs(value) {
      this.breadcrumbsLabels = [this.$t("feature.staff.list")];

      if (value) {
        this.breadcrumbsLabels[1] = value;
      } else if (this.$store.state.currentStaffName) {
        this.breadcrumbsLabels[1] = this.$store.state.currentStaffName;
      } else {
        this.breadcrumbsLabels[1] = this.$t("feature.staff.create");
      }
    }
  }
};
</script>

<style></style>
